var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScicalBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 177 149",
    style: {
      enableBackground: "new 0 0 177 149"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#002C77;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167,10h-26V6.3c0-3.3-2.5-6.1-5.8-6.3c-3.3-0.1-6.1,2.5-6.2,5.8c0,0.1,0,0.1,0,0.2v4H48V6.3 c0-3.3-2.5-6.1-5.8-6.3c-3.3-0.1-6.1,2.5-6.2,5.8c0,0.1,0,0.1,0,0.2v4H3.1C1.4,10,0,11.4,0,13.1v132.8c0,1.7,1.4,3.1,3.1,3.1 c0,0,0,0,0,0h170.8c1.7,0,3.1-1.4,3.1-3.1l0,0V13.1c0-1.7-1.4-3.1-3.1-3.1l0,0H167z M163.9,139H13.1c-1.7,0-3.1-1.4-3.1-3.1l0,0 V51.1c0-1.7,1.4-3.1,3.1-3.1c0,0,0,0,0,0h150.8c1.7,0,3.1,1.4,3.1,3.1v0v84.8C167,137.6,165.6,139,163.9,139L163.9,139z M163.9,38 H13.1c-1.7,0-3.1-1.4-3.1-3.1l0,0V23.1c0-1.7,1.4-3.1,3.1-3.1H36v3.8c0,3.3,2.5,6.1,5.8,6.3c3.3,0.1,6.1-2.5,6.2-5.8 c0-0.1,0-0.1,0-0.2v-4h81v3.8c0,3.3,2.5,6.1,5.8,6.3c3.3,0.1,6.1-2.5,6.2-5.8c0-0.1,0-0.1,0-0.2v-4h22.9c1.7,0,3.1,1.4,3.1,3.1v0 v11.8C167,36.6,165.6,38,163.9,38L163.9,38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114,96.8c-2.5,0-4.9,1.1-6.6,2.9l-6.7-3.1c0.2-0.9,0.3-1.9,0.3-2.8c0-7.2-5.8-13-13-13c-1,0-2,0.1-3,0.4 l-2.8-5.8c3.6-3.4,3.7-9.1,0.3-12.7c-3.4-3.6-9.1-3.7-12.7-0.3s-3.7,9.1-0.3,12.7c1.7,1.8,4.1,2.8,6.5,2.8c0.4,0,0.8,0,1.2-0.1 l2.8,5.8c-5.4,4.2-6.6,11.8-2.8,17.5L67,111.8c-1.2-0.6-2.6-0.9-4-0.9c-5,0-9,4-9,9s4,9,9,9s9-4,9-9c0-1.5-0.4-3-1.1-4.3l10.3-10.7 c5.7,3.5,13.2,2.1,17.2-3.2l6.7,3.1c0,0.4-0.1,0.7-0.1,1.1c0,5,4,9,9,9s9-4,9-9S119,96.8,114,96.8L114,96.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScicalBlue);
export default __webpack_public_path__ + "static/media/scical-blue.c7e0e7945c7e08fe4eecb6823ea379f0.svg";
export { ForwardRef as ReactComponent };